import React, { useEffect, useRef } from 'react';
import '../assets/css/BttPreloader.css';
import preloader from '../assets/img/logo/preloader.webp';

const BttPreloader = () => {
  const preloaderRef = useRef(null);

  useEffect(() => {
    const preloader = preloaderRef.current;
    if (!preloader) return;

    // Function to add the 'hide' class
    const hidePreloader = () => {
      preloader.classList.add('hide');
    };

    // Once transition ends, remove the element from the flow
    const handleTransitionEnd = () => {
      preloader.style.display = 'none';
    };

    preloader.addEventListener('transitionend', handleTransitionEnd);
    window.addEventListener('load', hidePreloader);

    // Ensure the preloader hides after 4 seconds regardless of load state
    const timeout = setTimeout(hidePreloader, 4000);

    return () => {
      preloader.removeEventListener('transitionend', handleTransitionEnd);
      window.removeEventListener('load', hidePreloader);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <div className="xb-backtotop">
        <a href="#" className="scroll">
          <i className="far fa-arrow-up"></i>
        </a>
      </div>
      <div
        id="xb-loadding"
        className="xb-loadding-container"
        ref={preloaderRef}
      >
        <div className="xb-loader">
          <div className="xb-loadding-inner">
            <img
              src={preloader}
              alt=""
              className="preloader-logo"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BttPreloader;
